import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import { __awaiter } from '../../_virtual/_tslib.js';

class GetVideoDuration {
  execute(file) {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        const objectURL = URL.createObjectURL(file);
        const onLoadedMetadata = () => {
          URL.revokeObjectURL(objectURL);
          video.removeEventListener('loadedmetadata', onLoadedMetadata);
          video.removeEventListener('error', onError);
          resolve(video.duration);
        };
        const onError = error => {
          URL.revokeObjectURL(objectURL);
          video.removeEventListener('loadedmetadata', onLoadedMetadata);
          video.removeEventListener('error', onError);
          reject(error);
        };
        video.src = objectURL;
        video.addEventListener('loadedmetadata', onLoadedMetadata);
        video.addEventListener('error', onError);
      });
    });
  }
}

export { GetVideoDuration };
